module.exports = __webpack_public_path__ + "0ac83b8dcb5b7fc3e4f1d4a1420b46ae.svg";